import { Group, Radio, Table } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { IncomingInspectionsGetRequest } from "@sizlcorp/sizl-api-document/dist/models";
import React, { useEffect } from "react";

interface SubInspectionTableProps {
  disabled?: boolean;
  title: string;
  columns: string[];
  form: UseFormReturnType<IncomingInspectionsGetRequest>;
}

const SubInspectionTable: React.FC<SubInspectionTableProps> = ({
  disabled,
  title,
  columns,
  form,
}) => {
  // form에 초기값이 없으면 여기서 세팅
  useEffect(() => {
    if (!form.values.inspectionResults || form.values.inspectionResults.length === 0) {
      form.setFieldValue(
        "inspectionResults",
        columns.map((col) => ({ key: col, isPassed: true })),
      );
    }
  }, [columns, form]);

  const handleRadioChange = (key: string, value: string) => {
    const updated = form.values.inspectionResults?.map((item) =>
      item.key === key ? { ...item, isPassed: value === "true" } : item,
    );
    form.setFieldValue("inspectionResults", updated);
  };

  return (
    <Table withBorder withColumnBorders>
      <thead>
        <tr>
          <th rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
            {title}
          </th>
          {columns.map((column) => (
            <th key={column} style={{ textAlign: "center" }}>
              {column}
            </th>
          ))}
        </tr>
        <tr>
          {columns.map((column) => {
            const selected = form.values.inspectionResults?.find((i) => i.key === column);
            return (
              <td key={column} style={{ border: "1px solid #ccc" }}>
                <Radio.Group
                  value={String(selected?.isPassed)}
                  onChange={(value) => handleRadioChange(column, value)}
                >
                  <Group p="xl" style={{ justifyContent: "center" }}>
                    <Radio disabled={disabled} value="true" label="O" fw="bold" />
                    <Radio disabled={disabled} value="false" label="X" fw="bold" />
                  </Group>
                </Radio.Group>
              </td>
            );
          })}
        </tr>
      </thead>
    </Table>
  );
};

export default SubInspectionTable;
